// datadogApplicationId/datadogClientToken are the future-client RUM
// application (Datadog > Digital Experience > RUM > Application Management),
// shared with environment.production.ts - one RUM app across environments,
// distinguished by the `env` tag below, matching edu-clients' own RUM app
// (same datadogAppId for staging and production there too).
//
// This file is swapped in for src/environments/environment.ts via
// angular.json's `fileReplacements` under the "staging" build
// configuration - it is not read from a `.env` file or any environment-
// variable mechanism. See AGENTS.md's "Known upstream issues" /
// load-bearing workarounds notes for the fuller picture.
// apps.* URLs are proxied through edge-gateway (antares), same as edu-clients'
// apps config - copied from edu-clients/src/environments/environment.staging.ts
// rather than re-derived, since these are the same backend services.
const edgeGatewayUrl = 'https://staging-api.presence.com';

export const environment = {
  datadogApplicationId: 'f1d3f5fa-c4df-4297-8c66-ae779f0eb271',
  datadogClientToken: 'pub9ec3b4e62f5cd3c5c4d8015cae1a7df4',
  env: 'staging',
  configCatKey: 'configcat-sdk-1/DgLbCHEjckGEDa0uS7QeUQ/rK44dge5j02ceGUeOlJwlQ',
  apps: {
    apiWorkplace: {
      url: `${edgeGatewayUrl}/workplace`,
    },
    chiron: {
      url: `${edgeGatewayUrl}/chiron`,
    },
    mizar: {
      url: `${edgeGatewayUrl}/mizar`,
    },
    sirius: {
      url: `${edgeGatewayUrl}/sirius`,
    },
  },
};
